import { VBtn } from 'vuetify/lib/components/VBtn';
import { VCol } from 'vuetify/lib/components/VGrid';
import { VCombobox } from 'vuetify/lib/components/VCombobox';
import { VContainer } from 'vuetify/lib/components/VGrid';
import { VForm } from 'vuetify/lib/components/VForm';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VInput } from 'vuetify/lib/components/VInput';
import { VRow } from 'vuetify/lib/components/VGrid';
import { VSimpleTable } from 'vuetify/lib/components/VDataTable';
import { VSkeletonLoader } from 'vuetify/lib/components/VSkeletonLoader';
import { VTextField } from 'vuetify/lib/components/VTextField';

var render = function render() {
  var _vm = this,
    _c = _vm._self._c;
  return _c('core-n20-dialog', {
    attrs: {
      "isOpen": _vm.isOpen,
      "max-width": "900"
    },
    on: {
      "close": function ($event) {
        return _vm.$emit('close');
      }
    },
    scopedSlots: _vm._u([{
      key: "title",
      fn: function () {
        return [_vm._v("\n    " + _vm._s(_vm.$i18n_t('IS.AssetMgmt.edit.editAsset')) + "\n  ")];
      },
      proxy: true
    }, {
      key: "buttons",
      fn: function () {
        return [_c('core-button', {
          attrs: {
            "color": _vm.color,
            "prepend-icon": "fa-save",
            "solid-icon": "",
            "disabled": !_vm.formValid
          },
          on: {
            "click": _vm.saveAsset
          }
        }, [_vm._v("\n      " + _vm._s(_vm.$i18n_t('Common.save')) + "\n    ")])];
      },
      proxy: true
    }])
  }, [_c(VContainer, {
    staticClass: "pa-0 assetmgmt-edit",
    attrs: {
      "fluid": ""
    }
  }, [_c(VForm, {
    ref: "editForm",
    model: {
      value: _vm.formValid,
      callback: function ($$v) {
        _vm.formValid = $$v;
      },
      expression: "formValid"
    }
  }, [_c(VRow, [_c(VCol, {
    staticClass: "py-0 mb-2",
    attrs: {
      "cols": "12"
    }
  }, [_vm._v("\n          " + _vm._s(`${_vm.$i18n_t('DigitalTwin.DigitalTwin.states.showDtwinDetails')}:`) + "\n          "), _c('router-link', {
    attrs: {
      "to": `/digitaltwin-mgmt/${_vm.twinObject.id}`
    }
  }, [_c('span', {
    class: `${_vm.color}--text`
  }, [_vm._v(_vm._s(_vm.twinObject.title))]), _vm._v("\n             \n            "), _c(VIcon, {
    attrs: {
      "color": _vm.color,
      "small": ""
    }
  }, [_vm._v("fal fa-external-link")])], 1)], 1)], 1), _c(VRow, [_c(VCol, {
    staticClass: "pb-0",
    attrs: {
      "cols": "12",
      "md": "6"
    }
  }, [_c(VTextField, {
    staticClass: "required",
    attrs: {
      "label": _vm.$i18n_t('DigitalTwin.DigitalTwin.enterTwinTitle'),
      "color": _vm.color,
      "outlined": _vm.inpOutlined,
      "filled": _vm.inpFilled,
      "rules": [v => !!v || _vm.$i18n_t('Common.fieldRequired')],
      "hide-details": "auto",
      "clearable": "",
      "required": ""
    },
    model: {
      value: _vm.twinObject.title,
      callback: function ($$v) {
        _vm.$set(_vm.twinObject, "title", $$v);
      },
      expression: "twinObject.title"
    }
  })], 1), _c(VCol, {
    staticClass: "pb-0",
    attrs: {
      "cols": "12",
      "md": "6"
    }
  }, [_c('core-tags', {
    attrs: {
      "tags": _vm.get(_vm.twinObject, 'data.tags', [])
    },
    on: {
      "update:tags": _vm.setTags
    }
  })], 1), _c(VCol, {
    attrs: {
      "cols": "12",
      "md": "6"
    }
  }, [_vm.twinObject.data.assetManagement ? _c(VCombobox, {
    attrs: {
      "color": _vm.color,
      "outlined": _vm.inpOutlined,
      "filled": _vm.inpFilled,
      "label": _vm.$i18n_t('NiotaClassic.Devices.form.operationalStatus'),
      "items": _vm.operationalStatusItems,
      "return-object": false,
      "item-text": "text",
      "item-value": "value",
      "clearable": "",
      "hide-details": ""
    },
    scopedSlots: _vm._u([{
      key: "selection",
      fn: function () {
        return [_vm.operationalStatus[parseInt(_vm.twinObject.data.assetManagement.operationalStatus)] ? [_vm._v("\n                " + _vm._s(_vm.operationalStatus[parseInt(_vm.twinObject.data.assetManagement.operationalStatus)]) + "\n              ")] : [_vm._v("\n                " + _vm._s(_vm.twinObject.data.assetManagement.operationalStatus) + "\n              ")]];
      },
      proxy: true
    }], null, false, 432123313),
    model: {
      value: _vm.twinObject.data.assetManagement.operationalStatus,
      callback: function ($$v) {
        _vm.$set(_vm.twinObject.data.assetManagement, "operationalStatus", $$v);
      },
      expression: "twinObject.data.assetManagement.operationalStatus"
    }
  }) : _vm._e()], 1), _c(VCol, {
    staticClass: "mb-0 pb-0",
    attrs: {
      "cols": "12"
    }
  }, [_c('p', {
    staticClass: "card-description mt-2 mb-0 pb-0",
    domProps: {
      "innerHTML": _vm._s(_vm.$i18n_t('IS.AssetMgmt.edit.trackerDeviceDescription'))
    }
  })]), ((_vm.twinObject.data.assetManagement || {}).deviceIds || []).length === 0 ? _c(VCol, [_c(VBtn, {
    class: 'v-btn-x px-3 mx-1 v-btn--rounded bg-rounded-button-' + _vm.color,
    attrs: {
      "color": _vm.color,
      "rounded": "",
      "text": ""
    },
    on: {
      "click": function ($event) {
        return _vm.addNewDevice(-1);
      }
    }
  }, [_c(VIcon, {
    attrs: {
      "dark": ""
    }
  }, [_vm._v("fal fa-plus")]), _vm._v("\n              " + _vm._s(_vm.$i18n_t('IS.AssetMgmt.edit.addDevice')) + "\n          ")], 1)], 1) : _vm._e(), _vm.deviceData.length === 0 && _vm.twinObject.data.assetManagement && (_vm.twinObject.data.assetManagement.deviceIds || []).length > 0 ? _c(VCol, [_c(VSimpleTable, [_c('tbody', _vm._l(_vm.twinObject.data.assetManagement.deviceIds, function (id, i) {
    return _c('tr', {
      key: `asset-device-${i}`
    }, [_c('td', [_c(VSkeletonLoader, {
      attrs: {
        "type": "heading"
      }
    })], 1), _c('td', [_c(VSkeletonLoader, {
      attrs: {
        "type": "heading"
      }
    })], 1), _c('td', [_c(VSkeletonLoader, {
      attrs: {
        "type": "heading"
      }
    })], 1)]);
  }), 0)])], 1) : _vm.deviceData.length ? _c(VCol, {
    attrs: {
      "cols": "12"
    }
  }, [_c(VSimpleTable, [_c('tbody', _vm._l(_vm.deviceData, function (deviceId, i) {
    return _c('tr', {
      key: `asset-device-${i}`
    }, [_c('td', [_vm.deviceData[i].deviceId ? [_c('a', {
      attrs: {
        "href": `/#/niota-classic/devices/${_vm.deviceData[i].deviceId}/details`,
        "target": "_blank"
      }
    }, [_vm._v("\n                      » " + _vm._s(_vm.deviceData[i].deviceTitle) + " (" + _vm._s(_vm.$i18n_t('Common.id')) + ":\n                      " + _vm._s(_vm.deviceData[i].deviceId) + ")\n                    ")])] : _vm._e()], 2), _c('td', [_vm.deviceData[i].properties && _vm.deviceData[i].properties.operational_status ? [_vm._v("\n                    " + _vm._s(_vm.operationalStatus[parseInt(_vm.deviceData[i].properties.operational_status.value)]) + "\n                  ")] : _vm._e()], 2), _c('td', {
      staticStyle: {
        "width": "310px"
      }
    }, [_c(VTextField, {
      staticClass: "required",
      attrs: {
        "label": _vm.$i18n_t('IS.AssetMgmt.edit.trackerDevice'),
        "disabled": _vm.isLoading,
        "loading": !_vm.deviceData[i].deviceId,
        "color": _vm.color,
        "outlined": _vm.inpOutlined,
        "filled": _vm.inpFilled,
        "rules": _vm.euiRules,
        "hide-details": "auto",
        "clearable": "",
        "required": ""
      },
      on: {
        "change": function ($event) {
          return _vm.fetchIotHubDetails(i);
        }
      },
      scopedSlots: _vm._u([{
        key: "append-outer",
        fn: function () {
          return [_c(VBtn, {
            class: `my-0 v-btn-x v-btn--rounded bg-rounded-button-${_vm.color}`,
            attrs: {
              "color": _vm.color,
              "icon": "",
              "info": "",
              "fab": "",
              "text": ""
            },
            on: {
              "click": function ($event) {
                return _vm.removeDevice(i);
              }
            }
          }, [_c(VIcon, {
            attrs: {
              "color": _vm.color,
              "dark": "",
              "small": ""
            }
          }, [_vm._v("fal fa-trash-alt")])], 1)];
        },
        proxy: true
      }], null, true),
      model: {
        value: _vm.deviceData[i].deviceEui,
        callback: function ($$v) {
          _vm.$set(_vm.deviceData[i], "deviceEui", $$v);
        },
        expression: "deviceData[i].deviceEui"
      }
    }), _c(VInput, {
      staticStyle: {
        "display": "none"
      },
      attrs: {
        "rules": _vm.requiredRule
      },
      model: {
        value: _vm.deviceData[i].deviceId,
        callback: function ($$v) {
          _vm.$set(_vm.deviceData[i], "deviceId", $$v);
        },
        expression: "deviceData[i].deviceId"
      }
    })], 1)]);
  }), 0)])], 1) : _vm._e()], 1)], 1)], 1)], 1);
};
var staticRenderFns = [];
export { render, staticRenderFns };